import type {} from '@angular/localize/init';
import { appRoutesI18nCache } from '../i18n-cache';

export function betOnActionRouteI18n(): string {
  return (appRoutesI18nCache['bet-on-action'] ??=
    $localize`:url-segment@@betgenius-bet-on-action-url-segment:bet-on-action`);
}
